import { throttle } from 'lodash';
const headerEl = document.querySelector('.header');

const setHeaderHeightVar = () => {
  document.documentElement.style.setProperty('--header-height', headerEl.clientHeight / 16 + 'rem');
};

setHeaderHeightVar();
window.addEventListener('resize', throttle(setHeaderHeightVar, 750));
